<template>
  <!-- 关键：确保容器高度填满，滚动生效 -->
  <div class="video-page" ref="pageWrap">
    <!--顶部导航-->
    <div class="video-header">
<!--      <img @click="$parent.goNav('/home')" src="/static/image/back.png" class="back-icon" alt="">-->
      <div class="title">影片列表</div>
      <div class="placeholder"></div>
    </div>

    <!--横向分类标签 -->
    <div class="category-wrap">
      <div
        class="category-item"
        :class="{active:currentTypeId == item.type_id}"
        v-for="item in typeList"
        :key="item.type_id"
        @click="switchCategory(item)"
      >
        {{ item.type_name }}
      </div>
    </div>

    <!--滚动容器单独抽离！重点修复滚动监听 -->
    <div class="scroll-container" @scroll="onScroll">
      <!--影片列表 -->
      <div class="video-wrap" v-if="videoList.length > 0">
        <div
          class="video-item"
          v-for="(item,index) in videoList"
          :key="index"
          @click="goPlayer(item)"
        >
          <div class="cover-box">
            <img class="cover" :src="item.vod_pic" alt="">
            <div class="play-icon">▶</div>
            <!-- VIP付费标识：登录用户并且不是VIP才显示 -->
            <div class="vip-tag" >VIP</div>
          </div>
          <div class="video-name">{{ item.vod_name }}</div>
        </div>
      </div>

      <!--空数据提示-->
      <div class="empty-tip" v-else>
        <div class="empty-icon">🎬</div>
        <div class="text">暂无影片数据</div>
      </div>

      <!--底部加载状态 -->
      <div class="load-more-tip" v-if="videoList.length>0">
        <span v-if="loadingMore">加载中...</span>
        <span v-else-if="noMore">没有更多数据</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoList",
  data() {
    return {
      typeList: [], //分类数组
      currentTypeId: 0, //当前选中分类ID
      videoList: [], //当前分类影片

      page: 1,
      limit: 30,
      loadingMore: false, //防止重复请求
      noMore: false, //是否没有下一页
      vipInfo: {
        try_seconds: 0,
        is_vip: false,
        vip_end_time: 0,
        vip_expire_date: null
      }
    }
  },
  mounted() {
    this.getTypeList()
  },
methods: {
    // 获取分类列表
    getTypeList() {
      let that = this
      that.$parent.showLoading();
      that.$apiFun.post('/api/vodTypeList', {}).then(res => {
        that.$parent.hideLoading();
        console.log('分类接口：', res);
        if (res.code == 200 && res.data.length > 0) {
          that.typeList = res.data
          // 保存会员信息
          if(res.vip_info){
            that.vipInfo = res.vip_info
          }
          that.currentTypeId = res.data[0].type_id
          that.resetPage()
          that.getVideoList(that.currentTypeId, true)
        }
      }).catch(err => {
        that.$parent.hideLoading();
        console.log("分类请求失败", err)
      })
    },

    resetPage() {
      this.page = 1
      this.noMore = false
      this.videoList = []
    },

    getVideoList(typeId, isRefresh = false) {
      if(this.loadingMore || (this.noMore && !isRefresh)) return
      let that = this
      that.loadingMore = true

      const params = new URLSearchParams();
      params.append('type_id', typeId);
      params.append('page', that.page);
      params.append('limit', that.limit);

      that.$apiFun.get(`/api/vodList?${params.toString()}`).then(res => {
        that.loadingMore = false
        console.log('影片列表', res);
        if (res.code == 200) {
          // 更新会员信息
          if(res.vip_info){
            that.vipInfo = res.vip_info
          }
          if(isRefresh){
            that.videoList = res.data || []
          }else{
            that.videoList.push(...res.data)
          }
          if(res.data.length < that.limit){
            that.noMore = true
          }
        }
      }).catch(err => {
        that.loadingMore = false
        console.log("影片请求异常", err)
      })
    },

    switchCategory(item) {
      if(this.currentTypeId === item.type_id) return;
      this.currentTypeId = item.type_id
      this.resetPage()
      this.getVideoList(item.type_id, true)
    },

    onScroll(e) {
      const dom = e.target;
      const distanceBottom = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
      if (distanceBottom < 100) {
        if(!this.noMore && !this.loadingMore){
          this.page++
          this.getVideoList(this.currentTypeId)
        }
      }
    },

    goPlayer(item) {
      const token = localStorage.getItem('token');
      if (!token) {
        const confirmResult = window.confirm('请先登录账号后观看视频');
        if (confirmResult) {
          this.$parent.goNav('/login');
        }
        return;
      }

      let playUrl = encodeURIComponent(item.vod_play_url)
      let cover = encodeURIComponent(item.vod_pic)
      let title = encodeURIComponent(item.vod_name)
      // 传递会员状态与试看时长到播放器页面
      const isVip = this.vipInfo.is_vip ? 1 : 0;
      const trySeconds = this.vipInfo.try_seconds;
      this.$parent.goNav(`/livePlayer?flvUrl=${playUrl}&cover=${cover}&title=${title}&type_id=${item.type_id}&id=${item.id}&is_vip=${isVip}&try_seconds=${trySeconds}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.video-page {
  background: #ede9e7;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.video-header {
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #ede9e7;
  flex-shrink: 0;
  .back-icon {
    width: 24px;
    cursor: pointer;
    transition: transform 0.2s ease;
    &:active {
      transform: scale(0.88);
    }
  }
  .title {
    flex: 1;
    text-align: center;
    font-size: 19px;
    color: #cf866b;
    font-weight: bold;
  }
  .placeholder {
    width: 24px;
  }
}

.category-wrap {
  display: flex;
  overflow-x: auto;
  padding: 10px 12px;
  gap: 10px;
  background: #ede9e7;
  flex-shrink: 0;
  &::-webkit-scrollbar {
    display: none;
  }
  .category-item {
    white-space: nowrap;
    padding: 6px 16px;
    border-radius: 20px;
    background: #ffffff;
    color: #666;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
    &.active {
      background: #cf866b;
      color: #fff;
    }
    &:active {
      transform: scale(0.94);
    }
  }
}

// 独立滚动容器 核心修复点
.scroll-container{
  flex:1;
  overflow-y: auto;
  padding-bottom:30px;
}

.video-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 0 12px;
  gap: 12px;
  .video-item {
    width: calc(50% - 6px);
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(207, 134, 107, 0.12);
    transition: all 0.22s ease;
    cursor: pointer;
    &:active {
      transform: scale(0.96);
      box-shadow: 0 1px 6px rgba(207, 134, 107, 0.08);
    }
    .cover-box {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%; /*16:9封面比例*/
      overflow: hidden;
      .cover {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 44px;
        height: 44px;
        background: linear-gradient(135deg, rgba(207, 134, 107, 0.75), rgba(207, 134, 107, 0.4));
        border-radius: 50%;
        color: #fff;
        text-align: center;
        line-height: 44px;
        font-size: 16px;
      }
      // VIP标签样式 右上角
      .vip-tag{
        position: absolute;
        top: 8px;
        right: 8px;
        padding: 2px 8px;
        background: #ff4d4f;
        color: #fff;
        font-size: 11px;
        border-radius: 4px;
      }
    }
    .video-name {
      color: #333;
      font-size: 14px;
      padding: 10px 10px;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

.empty-tip {
  margin-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
    opacity: 0.6;
  }
  .text {
    color: #999;
    font-size: 15px;
  }
}

.load-more-tip{
  padding:16px 0;
  text-align:center;
  color:#999;
  font-size:13px;
}
</style>



// WEBPACK FOOTER //
// src/components/zhibo.vue